import React, { Fragment } from 'react'
// import missionVisionIcon from '../../assets/icons/man-with-suitcase.svg'
import missionIcon from '../../assets/icons/mi2.png';
import VisionIcon from '../../assets/icons/vi1.png';
import ourTeamImg from '../../assets/img/bg-home.png'
// import ourJourneyImg from '../../assets/img/nigeriaavition.png'
import cargoJourneyImg from '../../assets/img/journey/cargo.png'
import bdaJourneyImg from '../../assets/img/journey/bda.png'
import tollJourneyImg from '../../assets/img/journey/toll.png'
import tollJourneyImg2 from '../../assets/img/journey/toll2.png'
import fmsJourneyImg from '../../assets/img/journey/fms.png'

import WhoWeAre from './who-we-are'
// import OurJourney from './our-journey'
import MissionVision from './mission-vision'
// import OurTeam from './our-team'
import PageBannerComponent from "../../shared/components/pageBanner";

class AboutPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      whoWeAre: {
        heading: 'Who we are',
        body:
          'AviTech leverages on cutting-edge software technology to capture data, automate payments and provide Big data intelligence to the Aviation Sector. AviTech is specialized in the development and implementation of innovative technological products and solutions with an outstanding track record in applying information, communication ' +
          'and technological (ICT) solutions across various sectors around Africa. '
      },
      ourJourney: {
        heading: 'Our Journey',
        body: [
          {
            title: "",
            date: '2012',
            image: cargoJourneyImg,
            content:
              "AviTech launched the Aviation Revenue Automation Project (ARAP). Launched Passenger Information System (Avicollect)"
          },
          {
            title: '',
            date: '2013',
            image: tollJourneyImg,
            content:
              'Launched Toll Automation System in Abuja.'
          },
          {
            title: '',
            date: '2014',
            image: tollJourneyImg2,
            content: "Launched Toll Automation System in Lagos. Launched Electronic Invoicing & Payment Platform for the aviation sector. Launched Electric Metering System"
          },
          {
            title: '',
            date: '2015',
            image: fmsJourneyImg,
            content: 'Launched Payment automation for aviation fueling'
          },
          {
            title: '',
            date: '2016',
            image: cargoJourneyImg,
            content: 'Launched Aviation Cargo Automation. Launched 360 degrees view & business '
          },
          {
            title: '',
            date: '2017',
            image: bdaJourneyImg,
            content: 'Nationwide activation of electronic invoicing (Billing Data Aggregator). Partner with key stakeholders to launch cashless system'
          }
        ]
      },
      missionVision: {
        heading: '',
        body: [
          {
            icon: missionIcon,
            title: 'Mission',
            content:
              'To deliver future technologies to solve today’s aviation challenges across Africa'
          },
          {
            icon: VisionIcon,
            title: 'Vision',
            content:
              'Providing innovative data collection solutions and payment automation to developing economies across. Africa'
          }
        ]
      },
      ourTeam: {
        heading: 'Our Team',
        body: [
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          },
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          },
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          },
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          },
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          },
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          },
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          },
          {
            image: ourTeamImg,
            title: 'James Bond',
            content: 'Team Manager'
          }
        ]
      }
    }
  }

  render() {
    return (
      <Fragment>
          <PageBannerComponent title='Who We Are' subTitle=''/>

        <div className="container-fluid" style={{paddingLeft:0,paddingRight:0}}>
          {/* who we are section */}
          <WhoWeAre content={this.state.whoWeAre} />
            {/* mission and vision section */}
          <MissionVision content={this.state.missionVision} />
          {/* our journey section */}
          {/*<OurJourney content={this.state.ourJourney} />*/}
          {/* our team section */}
          {/*<OurTeam content={this.state.ourTeam} />*/}
        </div>
      </Fragment>
    )
  }
}

export default AboutPage



// WEBPACK FOOTER //
// ./src/views/about/index.js